import { FC, useState } from 'react';
import { TemplateEditViews } from '../../common/types';
import {
  QueryParamContext,
  QueryParamContextState,
  useQueryParamContext,
} from '../../context/QueryParamContext';

export type TemplateStateContextProviderProps = {
  locale?: string;
  campaignId?: number | null;
  templateId?: number | null;
  view?: string;
  experimentFlow?: boolean;
  workflowNodeFlow?: boolean;
  currentLocale?: string;
  setCurrentLocale?: (locale: string) => void;
};

export const TemplateStateContextProvider: FC<
  React.PropsWithChildren<TemplateStateContextProviderProps>
> = ({ children, ...props }) => {
  const [campaignId, setCampaignId] = useState(props?.campaignId || 0);
  const [experimentFlow] = useState(props?.experimentFlow || false);

  const [locale, setLocale] = useState(props?.currentLocale || props?.locale || '');
  const [templateId, setTemplateId] = useState(props?.templateId || 0);
  const [view, setView] = useState(props?.view || TemplateEditViews.settings);
  const [workflowNodeFlow] = useState(props?.workflowNodeFlow || false);

  const handleUpdateLocale = (value: string) => {
    setLocale(value);
    props?.setCurrentLocale?.(value);
  };

  const context: QueryParamContextState = {
    campaignId,
    experimentFlow,
    isJourneyAssociated: true,
    locale,
    setCampaignId,
    setLocale: handleUpdateLocale,
    setTemplateId,
    setView,
    templateId,
    view,
    workflowNodeFlow,
  };

  return <QueryParamContext.Provider value={context}>{children}</QueryParamContext.Provider>;
};

export const useTemplateStateContext = useQueryParamContext;
